import { useState } from "react";
import { useTranslation } from "react-i18next";

import { OrganizationUser } from "@organization/models/OrganizationUser";
import { OrganizationUserDropDown } from "@users/components/OrganizationUserDropDown";

import { EditApplicationAssociationsForm } from "./EditApplicationAssociationsForm";

interface Props {
  userId?: string;
  userDisplayName?: string;
  applicationId?: string;
  onCancel: () => void;
  onSuccess: () => void;
}

export function EditApplicationUser(props: Readonly<Props>) {
  const { userId, userDisplayName, applicationId, onCancel, onSuccess } = props;

  const { t } = useTranslation(undefined, {
    keyPrefix: "user.applications"
  });

  const [selectedUserId, setSelectedUserId] = useState<string | undefined>(
    userId
  );
  const [selectedUserDisplayName, setSelectedUserDisplayName] = useState<
    string | undefined
  >(userDisplayName);

  function handleUserChange(user: OrganizationUser | undefined) {
    if (user) {
      setSelectedUserId(user.id);
      setSelectedUserDisplayName(user.displayName);
    } else {
      setSelectedUserId(undefined);
      setSelectedUserDisplayName(undefined);
    }
  }

  return (
    <div
      className="flex h-6 min-h-min flex-col gap-10"
      data-testid="edit-application-user-content"
    >
      <div className="place-content-center">
        <OrganizationUserDropDown
          label={t("user.label")}
          selectedUserId={selectedUserId}
          disabled={selectedUserId !== undefined}
          onUserChange={handleUserChange}
        />
      </div>
      {selectedUserId && selectedUserDisplayName && (
        <EditApplicationAssociationsForm
          userId={selectedUserId}
          userDisplayName={selectedUserDisplayName}
          applicationId={applicationId}
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
      )}
    </div>
  );
}
